import { Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from '@env/environment';
import { TrackingService } from '@core/services';

@Component({
    selector: 'gh-side-menu',
    templateUrl: 'side-menu.component.html',
    standalone: false
})

export class SideMenuComponent {
  @Input() menu: any[];
  @Output() whenMenuClose: EventEmitter<any> = new EventEmitter<any>();
  cdnPath = environment.cdnPath;
  website = environment.website;
  webapp = environment.webapp;
  support = environment.support;
  root = environment.root;

  constructor(
    private trackingService: TrackingService
  ) { }

  closeMenu() {
    this.whenMenuClose.emit();
  }

  navClick(label: string, location: string) {
    this.trackingService.setDataLayerAttributes({
      event: 'interactionEvent',
      event_name: 'navigation',
      events: {
        click_text: label,
        feature: 'blog',
        environment: environment.env,
        location
      }
    });
  }

}
